import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getChannelMessages } from '../../../api/messenger';

import { normalizeMessages } from '../../../components/Messenger/utils/normalizeMessages';

import { REQUEST } from '../../../constants/request';

export const fetchChannelMessages = createAsyncThunk(
  'messenger/fetchChannelMessages',
  async (args, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getChannelMessages(args.channelUid, {
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const currentLoading =
        getState().messenger.currentLoadings?.[arg.channelUid] || REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const fetchChannelMessagesExtraReducers = builder => {
  builder
    .addCase(fetchChannelMessages.pending, (state, { meta }) => {
      const { chatId } = meta.arg;
      state.currentLoadings[chatId] = REQUEST.pending;
      state.currentRequestIds[chatId] = meta.requestId;
    })
    .addCase(fetchChannelMessages.fulfilled, (state, { meta, payload }) => {
      const { chatId } = meta.arg;
      const { byId, allIds, byChatId } = normalizeMessages(state, payload);
      if (payload.length > 0) {
        const { chatId: messagesChatId } = payload[0];
        state.messages.byChatId[messagesChatId] = byChatId;
      }
      state.messages.byId = byId;
      state.messages.allIds = allIds;
      state.currentLoadings[chatId] = REQUEST.idle;
      state.currentRequestIds[chatId] = undefined;
    })
    .addCase(fetchChannelMessages.rejected, (state, { meta, payload }) => {
      const { chatId } = meta.arg;
      state.currentLoadings[chatId] = REQUEST.idle;
      state.currentRequestIds[chatId] = undefined;
      state.currentErrors[chatId] = payload;
    });
};
